import React, { useState } from "react";
import { Modal, Typography, Button, Checkbox, Select } from "antd";
const { Title, Paragraph } = Typography;


type ReConfirmModalProps = {
    useCase: string;
    visible: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

const ReConfirmModal: React.FC<ReConfirmModalProps> = ({
		useCase,
    visible,
    onConfirm,
    onCancel,
}) => {

		const title = useCase == "Approve" ? "Confirm Approval" : "Confirm Rejection";
		const text =  useCase == "Approve" ? "Your approval will trigger immediate permanent deletion of these files by the system. There will be no recovery possible. Proceed? " : "Your rejection will prevent permanent deletion of these files by the system. No changes will be made. Proceed?";
    return (
        <Modal
            open={visible}
            title={<Title level={4}>{title}</Title>}
            onCancel={onCancel}
            footer={[
                <Button key="no" onClick={onCancel}>
                    No
                </Button>,
                <Button
                    key="yes" type="primary" danger onClick={onConfirm}
                >
                    Yes
                </Button>,
            ]}
            centered
            destroyOnClose
        >
            <Paragraph>
                {text}
            </Paragraph>
        </Modal>
    );
};

export default ReConfirmModal;
